import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-object-allocation-register-history',
  templateUrl: './object-allocation-register-history.component.html',
  styleUrls: ['./object-allocation-register-history.component.css']
})
export class ObjectAllocationRegisterHistoryComponent implements OnInit {


  singleObjectAllocationRegisterData: any = []
  objectTemplateId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  objectAllocationRegisterList: any = []
  isLoading: any = false
  form: any | FormGroup
  objectInfoList: any = []
  usersList: any = []
  objectStatus: any = "ALL"
  objectInfoId: any = ""
  statusList: any = [
    "ALL", "REQUESTED", "VERIFIED", "APPROVED", "ISSUED", "RECEIVED", "REJECTED", "DEPLOYED", "RETURNED", "RETURN_RECEIVED"
  ]

  updateStatusList: any = [
    "REQUESTED", "VERIFIED", "APPROVED", "ISSUED", "RECEIVED", "REJECTED", "DEPLOYED", "RETURNED", "RETURN_RECEIVED"
  ]

  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";
  isStatusUpdate: any = false
  isStatusSubmited: any = false
  issueStatus: any = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectInfo()
  }

  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        console.log(response);
        this.objectInfoList = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }

  getObjectAllocationRegisterById(objectAllocationRegisterId: any){
    this.generic_service.getObjectAllocationRegisterById(objectAllocationRegisterId).subscribe(
      (response:any)=>{
        console.log(response);
        this.singleObjectAllocationRegisterData = []
        this.singleObjectAllocationRegisterData.push(response.response)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  remove(){
    document.getElementById("closeModalButton")?.click()
    this.objectTemplateId = ""
  }

  selectDelete(id:any,list: any){
    this.objectTemplateId = id;

    this.recordId = list.objectAllocationRegisterId
    this.recordName = list.givenName
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }

  refreshAll(){
    this.page = 1
    this.first = 0
    this.searchFilter = ""
  }


  getAllObjectAllocationRegistersByObjectId(){
    this.generic_service.getAllObjectAllocationRegistersByObjectId(this.objectInfoId).subscribe(
      (response:any)=>{
        console.log(response);
        this.objectAllocationRegisterList = []
        this.objectAllocationRegisterList = response.response
        this.count = response.response.length

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllObjectAllocationRegistersByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllObjectAllocationRegistersByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
        this.objectAllocationRegisterList = []
        this.count = 0
          return

        }
        this.objectAllocationRegisterList = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }



  deleteObjectAllocationRegister(){
    this.generic_service.deleteObjectAllocationRegister(this.objectTemplateId).subscribe(
      (response:any)=>{
        console.log(response);
        document.getElementById("closeModalDelete")?.click()
        this.toastr.success(response.message)
        this.clearData()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.errors[0].description)
      }
    )
  }

  changeStatusClick(){
    this.isStatusUpdate = !this.isStatusUpdate
  }

}